<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li>Escolas</li>
                        </ul>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Escolas</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label for="nomeEscola">Nome da Escola</label>
                                    <input type="text" class="form-control" name="nome" v-model="filter.nomeEscola" />
                                </div>

                                <div class="form-group col-md-6">
                                    <label for="planoServicoId">Pacote de Serviço</label>
                                    <select v-select="{ dataitem: 'PlanoServico', default: 'Todos' }" v-model="filter.planoServicoId" class="form-control" name="planoServicoId"></select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Tem Módulo Consultivo</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="temModuloConsultivo" v-model="filter.temModuloConsultivo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="temModuloConsultivo" v-model="filter.temModuloConsultivo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="temModuloConsultivo" v-model="filter.temModuloConsultivo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>


                                <div class="form-group col-md-6">
                                    <label>Cobrar</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="cobrar" v-model="filter.cobrar" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="cobrar" v-model="filter.cobrar" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="cobrar" v-model="filter.cobrar" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Ativo</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Inadimplência Sinalizada</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="sinalizarInadimplencia" v-model="filter.sinalizarInadimplencia" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="sinalizarInadimplencia" v-model="filter.sinalizarInadimplencia" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="sinalizarInadimplencia" v-model="filter.sinalizarInadimplencia" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Está Inadimplente</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="inadimplente" v-model="filter.inadimplente" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="inadimplente" v-model="filter.inadimplente" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="inadimplente" v-model="filter.inadimplente" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Box Bloqueado</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="bloquearSistema" v-model="filter.bloquearSistema" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="bloquearSistema" v-model="filter.bloquearSistema" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="bloquearSistema" v-model="filter.bloquearSistema" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>CNA Talk</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="temCnaTalk" v-model="filter.temCnaTalk" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="temCnaTalk" v-model="filter.temCnaTalk" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="temCnaTalk" v-model="filter.temCnaTalk" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Nome<i @click="executeOrderBy('escola.nomeEscola')" class="fa fa-sort"></i></th>
                                    <th>Pacote<i @click="executeOrderBy('planoServico.nome')" class="fa fa-sort"></i></th>
                                    <th>Tem Módulo Consultivo<i @click="executeOrderBy('TemModuloConsultivo')" class="fa fa-sort"></i></th>
                                    <th>Ativa<i @click="executeOrderBy('Ativo')" class="fa fa-sort"></i></th>
                                    <th>Cobrar Box<i @click="executeOrderBy('Cobrar')" class="fa fa-sort"></i></th>
                                    <th>Inadimplência Sinalizada<i @click="executeOrderBy('sinalizarInadimplencia')" class="fa fa-sort"></i></th>
                                    <th>Está Inadimplente<i @click="executeOrderBy('inadimplente')" class="fa fa-sort"></i></th>
                                    <th>Box Bloqueado<i @click="executeOrderBy('bloquearSistema')" class="fa fa-sort"></i></th>
                                    <th>CNA Talk<i @click="executeOrderBy('temCnaTalk')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.escola ? item.escola.nomeEscola : '--' }}</td>
                                    <td>{{ item.planoServico ? item.planoServico.nome : '--'}}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.temModuloConsultivo, 'badge-danger': !item.temModuloConsultivo }">{{item.temModuloConsultivo ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativo, 'badge-danger': !item.ativo }">{{item.ativo ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.cobrar, 'badge-danger': !item.cobrar }">{{item.cobrar ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.sinalizarInadimplencia, 'badge-danger': !item.sinalizarInadimplencia }">{{item.sinalizarInadimplencia ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.inadimplente, 'badge-danger': !item.inadimplente }">{{item.inadimplente ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.bloquearSistema, 'badge-danger': !item.bloquearSistema }">{{item.bloquearSistema ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.temCnaTalk, 'badge-danger': !item.temCnaTalk }">{{item.temCnaTalk ? 'Sim' : 'Não'}}</span></td>                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit({ escolaId: item.escolaId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>
                    <button class="btn-large-40 btn-red uppercase pull-left btn-header" @click="onExportFilters()">
                        Exportar Consulta
                    </button>
                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" size="lg" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="escolaId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formEdit from './form-edit'

    export default {
        name: 'escolabox',
        mixins: [base],
        components: { formEdit },
        data() {
            return {

                resources: {
                    filter: 'escolabox',
                    remove: 'escolabox'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    planoServicoId: "",
                    escolaId: ""
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            onExportFilters: function () {
                new Api('escolaBox/export').export(
                    this.filter
                ).then(data => {
                    var blob = new Blob([data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    var _a = document.createElement("a");
                    document.body.appendChild(_a);
                    _a.style.visibility = 'hidden';
                    _a.target = "_blank";
                    _a.href = window.URL.createObjectURL(blob);
                    _a.download = "exportacao-escola.xlsx"
                    _a.click();
                    _a.remove();

                });
            },
            openEdit: function (model) {
                this.escolaId = model.escolaId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>